// import React, { useState } from "react";
// import { useTranslation } from "react-i18next";
// import Navbar from "../../Components/Navbar";
// import Footer from "../../Components/Footer/Footer";
// import "./FullBuildingService.css";

// const FullBuildingService = () => {
//   const { t } = useTranslation();
//   const [form, setForm] = useState({
//     serviceType: "",
//     buildingType: "",
//     floors: "",
//     location: "",
//     preferredDate: "",
//     preferredTime: "",
//     budgetRange: "",
//     details: "",
//   });
//   const [submitting, setSubmitting] = useState(false);
//   const [submitted, setSubmitted] = useState(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setSubmitting(true);
//     setSubmitted(false);

//     try {
//       // TODO: integrate with your backend API (e.g. /full-building-request)
//       console.log("Full building request:", form);
//       // Simulate success
//       setTimeout(() => {
//         setSubmitting(false);
//         setSubmitted(true);
//       }, 500);
//     } catch (err) {
//       console.error("Error submitting full building request:", err);
//       setSubmitting(false);
//     }
//   };

//   return (
//     <>
//       <Navbar />

//       <main className="fb-page">
//         <section className="fb-hero">
//           <div className="fb-hero-container">
//             <div className="fb-hero-text">
//               <h1>
//                 {t("fullBuilding.title", {
//                   defaultValue: "Full Building Service Request",
//                 })}
//               </h1>
//               <p>
//                 {t("fullBuilding.subtitle", {
//                   defaultValue:
//                     "Planning work for an entire building or project? Share your details and our team will coordinate a tailored solution for electrical, plumbing, painting, interior and more.",
//                 })}
//               </p>

//               <div className="fb-hero-tags">
//                 <span>
//                   <i className="fas fa-city" />{" "}
//                   {t("fullBuilding.tag_projects", {
//                     defaultValue: "Apartments, offices & complexes",
//                   })}
//                 </span>
//                 <span>
//                   <i className="fas fa-users-cog" />{" "}
//                   {t("fullBuilding.tag_team", {
//                     defaultValue: "Dedicated project coordination",
//                   })}
//                 </span>
//                 <span>
//                   <i className="fas fa-file-invoice-dollar" />{" "}
//                   {t("fullBuilding.tag_quote", {
//                     defaultValue: "Custom quotation",
//                   })}
//                 </span>
//               </div>
//             </div>

//             <div className="fb-hero-sidecard">
//               <div className="fb-sidecard-icon">
//                 <i className="fas fa-building" />
//               </div>
//               <h3>
//                 {t("fullBuilding.side.title", {
//                   defaultValue: "Ideal For",
//                 })}
//               </h3>
//               <ul>
//                 <li>
//                   {t("fullBuilding.side.item1", {
//                     defaultValue: "Newly constructed full buildings",
//                   })}
//                 </li>
//                 <li>
//                   {t("fullBuilding.side.item2", {
//                     defaultValue: "Full renovation projects",
//                   })}
//                 </li>
//                 <li>
//                   {t("fullBuilding.side.item3", {
//                     defaultValue: "Multiple flats under one owner",
//                   })}
//                 </li>
//                 <li>
//                   {t("fullBuilding.side.item4", {
//                     defaultValue: "Corporate / commercial spaces",
//                   })}
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </section>

//         <section className="fb-form-section">
//           <div className="fb-form-container">
//             <div className="fb-form-header">
//               <h2>
//                 {t("fullBuilding.form.title", {
//                   defaultValue: "Tell us about your building",
//                 })}
//               </h2>
//               <p>
//                 {t("fullBuilding.form.subtitle", {
//                   defaultValue:
//                     "Please provide as much detail as possible so our team can call you with an accurate plan and quotation.",
//                 })}
//               </p>
//             </div>

//             <form className="fb-form" onSubmit={handleSubmit}>
//               {/* Service Type */}
//               <div className="fb-form-group">
//                 <label htmlFor="serviceType">
//                   {t("fullBuilding.form.serviceType", {
//                     defaultValue: "Required building service",
//                   })}{" "}
//                   <span className="fb-required">*</span>
//                 </label>
//                 <select
//                   id="serviceType"
//                   name="serviceType"
//                   value={form.serviceType}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="">
//                     {t("fullBuilding.form.service_placeholder", {
//                       defaultValue: "Select service type",
//                     })}
//                   </option>
//                   <option value="full_electric">
//                     {t("fullBuilding.form.options.full_electric", {
//                       defaultValue: "Full Building Electrical Service",
//                     })}
//                   </option>
//                   <option value="full_plumbing">
//                     {t("fullBuilding.form.options.full_plumbing", {
//                       defaultValue: "Full Building Plumbing Service",
//                     })}
//                   </option>
//                   <option value="full_painting">
//                     {t("fullBuilding.form.options.full_painting", {
//                       defaultValue: "Full Building Painting Service",
//                     })}
//                   </option>
//                   <option value="full_interior">
//                     {t("fullBuilding.form.options.full_interior", {
//                       defaultValue: "Full Building Interior Service",
//                     })}
//                   </option>
//                   <option value="mixed">
//                     {t("fullBuilding.form.options.mixed", {
//                       defaultValue: "Combination / Multiple Services",
//                     })}
//                   </option>
//                 </select>
//               </div>

//               {/* Building Type */}
//               <div className="fb-form-group">
//                 <label htmlFor="buildingType">
//                   {t("fullBuilding.form.buildingType", {
//                     defaultValue: "Building type",
//                   })}
//                 </label>
//                 <select
//                   id="buildingType"
//                   name="buildingType"
//                   value={form.buildingType}
//                   onChange={handleChange}
//                 >
//                   <option value="">
//                     {t("fullBuilding.form.building_placeholder", {
//                       defaultValue: "Select building type (optional)",
//                     })}
//                   </option>
//                   <option value="residential">
//                     {t("fullBuilding.form.building.residential", {
//                       defaultValue: "Residential (apartment / flat)",
//                     })}
//                   </option>
//                   <option value="commercial">
//                     {t("fullBuilding.form.building.commercial", {
//                       defaultValue: "Commercial / Office",
//                     })}
//                   </option>
//                   <option value="mixed_use">
//                     {t("fullBuilding.form.building.mixed_use", {
//                       defaultValue: "Mixed-use",
//                     })}
//                   </option>
//                 </select>
//               </div>

//               {/* Floors + Location */}
//               <div className="fb-form-row">
//                 <div className="fb-form-group">
//                   <label htmlFor="floors">
//                     {t("fullBuilding.form.floors", {
//                       defaultValue: "Number of floors",
//                     })}
//                   </label>
//                   <input
//                     type="number"
//                     id="floors"
//                     name="floors"
//                     min="1"
//                     placeholder={t("fullBuilding.form.floors_placeholder", {
//                       defaultValue: "e.g. 8",
//                     })}
//                     value={form.floors}
//                     onChange={handleChange}
//                   />
//                 </div>
//                 <div className="fb-form-group">
//                   <label htmlFor="location">
//                     {t("fullBuilding.form.location", {
//                       defaultValue: "Building location / area",
//                     })}
//                   </label>
//                   <input
//                     type="text"
//                     id="location"
//                     name="location"
//                     placeholder={t(
//                       "fullBuilding.form.location_placeholder",
//                       { defaultValue: "Area, city (e.g. Mirpur, Dhaka)" }
//                     )}
//                     value={form.location}
//                     onChange={handleChange}
//                   />
//                 </div>
//               </div>

//               {/* Date / Time */}
//               <div className="fb-form-row">
//                 <div className="fb-form-group">
//                   <label htmlFor="preferredDate">
//                     {t("fullBuilding.form.preferredDate", {
//                       defaultValue: "Preferred visit date",
//                     })}
//                   </label>
//                   <input
//                     type="date"
//                     id="preferredDate"
//                     name="preferredDate"
//                     value={form.preferredDate}
//                     onChange={handleChange}
//                   />
//                 </div>
//                 <div className="fb-form-group">
//                   <label htmlFor="preferredTime">
//                     {t("fullBuilding.form.preferredTime", {
//                       defaultValue: "Preferred time slot",
//                     })}
//                   </label>
//                   <input
//                     type="text"
//                     id="preferredTime"
//                     name="preferredTime"
//                     placeholder={t(
//                       "fullBuilding.form.preferredTime_placeholder",
//                       { defaultValue: "e.g. 10am–1pm" }
//                     )}
//                     value={form.preferredTime}
//                     onChange={handleChange}
//                   />
//                 </div>
//               </div>

//               {/* Budget */}
//               <div className="fb-form-group">
//                 <label htmlFor="budgetRange">
//                   {t("fullBuilding.form.budgetRange", {
//                     defaultValue: "Approximate budget (optional)",
//                   })}
//                 </label>
//                 <input
//                   type="text"
//                   id="budgetRange"
//                   name="budgetRange"
//                   placeholder={t(
//                     "fullBuilding.form.budgetRange_placeholder",
//                     { defaultValue: "e.g. 5–7 lakh, or Not sure" }
//                   )}
//                   value={form.budgetRange}
//                   onChange={handleChange}
//                 />
//               </div>

//               {/* Details */}
//               <div className="fb-form-group">
//                 <label htmlFor="details">
//                   {t("fullBuilding.form.details", {
//                     defaultValue: "Project details / description",
//                   })}{" "}
//                   <span className="fb-required">*</span>
//                 </label>
//                 <textarea
//                   id="details"
//                   name="details"
//                   rows={5}
//                   required
//                   placeholder={t(
//                     "fullBuilding.form.details_placeholder",
//                     {
//                       defaultValue:
//                         "Please mention scope (electric/plumbing/painting/interior), total flats, any existing drawings, timelines, and any other important notes.",
//                     }
//                   )}
//                   value={form.details}
//                   onChange={handleChange}
//                 />
//               </div>

//               {/* Info line */}
//               <p className="fb-form-note">
//                 <i className="fas fa-info-circle" />{" "}
//                 {t("fullBuilding.form.note", {
//                   defaultValue:
//                     "Our team will review your request and contact you by phone to discuss next steps and site visit.",
//                 })}
//               </p>

//               {/* Submit */}
//               <div className="fb-form-actions">
//                 <button
//                   type="submit"
//                   className="fb-submit-btn"
//                   disabled={submitting}
//                 >
//                   {submitting ? (
//                     <span>
//                       <i className="fas fa-spinner fa-spin" />{" "}
//                       {t("fullBuilding.form.submitting", {
//                         defaultValue: "Sending request...",
//                       })}
//                     </span>
//                   ) : (
//                     <span>
//                       <i className="fas fa-paper-plane" />{" "}
//                       {t("fullBuilding.form.submit", {
//                         defaultValue: "Submit Building Request",
//                       })}
//                     </span>
//                   )}
//                 </button>

//                 {submitted && (
//                   <span className="fb-form-success">
//                     <i className="fas fa-check-circle" />{" "}
//                     {t("fullBuilding.form.success", {
//                       defaultValue:
//                         "Thank you! We’ve received your request. Our team will contact you soon.",
//                     })}
//                   </span>
//                 )}
//               </div>
//             </form>
//           </div>
//         </section>
//       </main>

//       <Footer />
//     </>
//   );
// };

// export default FullBuildingService;






// import React, { useState } from "react";
// import { useTranslation } from "react-i18next";
// import { useNavigate } from "react-router-dom";
// import Navbar from "../../Components/Navbar";
// import Footer from "../../Components/Footer/Footer";
// import "./FullBuildingService.css";

// const FullBuildingService = () => {
//   const { t } = useTranslation();
//   const navigate = useNavigate();

//   // TODO: populate these from logged-in user profile
//   const [form, setForm] = useState({
//     name: "",
//     mobile: "",
//     serviceType: "",
//     buildingType: "",
//     floors: "",
//     location: "",
//     preferredDate: "",
//     preferredTime: "",
//     budgetRange: "",
//     details: "",
//   });

//   const [submitting, setSubmitting] = useState(false);
//   const [submitted, setSubmitted] = useState(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setSubmitting(true);
//     setSubmitted(false);

//     try {
//       // TODO: integrate with your backend API (e.g. /full-building-request)
//       console.log("Full building request:", form);
//       // Simulate success
//       setTimeout(() => {
//         setSubmitting(false);
//         setSubmitted(true);
//       }, 500);
//     } catch (err) {
//       console.error("Error submitting full building request:", err);
//       setSubmitting(false);
//     }
//   };

//   return (
//     <>
//       <Navbar />

//       <main className="fb-page">
//         {/* HERO */}
//         <section className="fb-hero">
//           <div className="fb-hero-container">
//             <div className="fb-hero-text">
//               <h1>
//                 {t("fullBuilding.title", {
//                   defaultValue: "Full Building Service Request",
//                 })}
//               </h1>
//               <p>
//                 {t("fullBuilding.subtitle", {
//                   defaultValue:
//                     "Planning work for an entire building or project? Share your details and our team will coordinate a tailored solution for electrical, plumbing, painting, interior and more.",
//                 })}
//               </p>

//               <div className="fb-hero-tags">
//                 <span>
//                   <i className="fas fa-city" />{" "}
//                   {t("fullBuilding.tag_projects", {
//                     defaultValue: "Apartments, offices & complexes",
//                   })}
//                 </span>
//                 <span>
//                   <i className="fas fa-users-cog" />{" "}
//                   {t("fullBuilding.tag_team", {
//                     defaultValue: "Dedicated project coordination",
//                   })}
//                 </span>
//                 <span>
//                   <i className="fas fa-file-invoice-dollar" />{" "}
//                   {t("fullBuilding.tag_quote", {
//                     defaultValue: "Custom quotation",
//                   })}
//                 </span>
//               </div>
//             </div>

//             {/* SIDE CARD */}
//             <div className="fb-hero-sidecard">
//                 <div className="fb-sidecard-header">
//                     <div className="fb-sidecard-icon">
//                     <i className="fas fa-building" />
//                     </div>
//                     <h3>
//                     {t("fullBuilding.side.title", {
//                         defaultValue: "Ideal For",
//                     })}
//                     </h3>
//                 </div>

//                 <ul>
//                     <li>
//                     {t("fullBuilding.side.item1", {
//                         defaultValue: "Newly constructed full buildings",
//                     })}
//                     </li>
//                     <li>
//                     {t("fullBuilding.side.item2", {
//                         defaultValue: "Full renovation projects",
//                     })}
//                     </li>
//                     <li>
//                     {t("fullBuilding.side.item3", {
//                         defaultValue: "Multiple flats under one owner",
//                     })}
//                     </li>
//                     <li>
//                     {t("fullBuilding.side.item4", {
//                         defaultValue: "Corporate / commercial spaces",
//                     })}
//                     </li>
//                 </ul>
//                 </div>

//           </div>
//         </section>

//         {/* FORM SECTION */}
//         <section className="fb-form-section">
//           <div className="fb-form-container">
//             <div className="fb-form-header">
//               <h2>
//                 {t("fullBuilding.form.title", {
//                   defaultValue: "Tell us about your building",
//                 })}
//               </h2>
//               <p>
//                 {t("fullBuilding.form.subtitle", {
//                   defaultValue:
//                     "Please provide as much detail as possible so our team can call you with an accurate plan and quotation.",
//                 })}
//               </p>
//             </div>

//             <form className="fb-form" onSubmit={handleSubmit}>
//               {/* Name & Mobile (read-only) */}
//               <div className="fb-form-row">
//                 <div className="fb-form-group">
//                   <label htmlFor="name">
//                     {t("fullBuilding.form.name", {
//                       defaultValue: "Your Name",
//                     })}{" "}
//                     <span className="fb-required">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     id="name"
//                     name="name"
//                     value={form.name}
//                     readOnly
//                     placeholder={t("fullBuilding.form.name_placeholder", {
//                       defaultValue: "Loaded from your profile",
//                     })}
//                   />
//                 </div>
//                 <div className="fb-form-group">
//                   <label htmlFor="mobile">
//                     {t("fullBuilding.form.mobile", {
//                       defaultValue: "Mobile Number",
//                     })}{" "}
//                     <span className="fb-required">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     id="mobile"
//                     name="mobile"
//                     value={form.mobile}
//                     readOnly
//                     placeholder={t("fullBuilding.form.mobile_placeholder", {
//                       defaultValue: "Your registered mobile",
//                     })}
//                   />
//                 </div>
//               </div>

//               {/* Service Type */}
//               <div className="fb-form-group">
//                 <label htmlFor="serviceType">
//                   {t("fullBuilding.form.serviceType", {
//                     defaultValue: "Required building service",
//                   })}{" "}
//                   <span className="fb-required">*</span>
//                 </label>
//                 <select
//                   id="serviceType"
//                   name="serviceType"
//                   value={form.serviceType}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="">
//                     {t("fullBuilding.form.service_placeholder", {
//                       defaultValue: "Select service type",
//                     })}
//                   </option>
//                   <option value="full_electric">
//                     {t("fullBuilding.form.options.full_electric", {
//                       defaultValue: "Full Building Electrical Service",
//                     })}
//                   </option>
//                   <option value="full_plumbing">
//                     {t("fullBuilding.form.options.full_plumbing", {
//                       defaultValue: "Full Building Plumbing Service",
//                     })}
//                   </option>
//                   <option value="full_painting">
//                     {t("fullBuilding.form.options.full_painting", {
//                       defaultValue: "Full Building Painting Service",
//                     })}
//                   </option>
//                   <option value="full_interior">
//                     {t("fullBuilding.form.options.full_interior", {
//                       defaultValue: "Full Building Interior Service",
//                     })}
//                   </option>
//                   <option value="mixed">
//                     {t("fullBuilding.form.options.mixed", {
//                       defaultValue: "Combination / Multiple Services",
//                     })}
//                   </option>
//                 </select>
//               </div>

//               {/* Building Type */}
//               <div className="fb-form-group">
//                 <label htmlFor="buildingType">
//                   {t("fullBuilding.form.buildingType", {
//                     defaultValue: "Building type",
//                   })}
//                 </label>
//                 <select
//                   id="buildingType"
//                   name="buildingType"
//                   value={form.buildingType}
//                   onChange={handleChange}
//                 >
//                   <option value="">
//                     {t("fullBuilding.form.building_placeholder", {
//                       defaultValue: "Select building type (optional)",
//                     })}
//                   </option>
//                   <option value="residential">
//                     {t("fullBuilding.form.building.residential", {
//                       defaultValue: "Residential (apartment / flat)",
//                     })}
//                   </option>
//                   <option value="commercial">
//                     {t("fullBuilding.form.building.commercial", {
//                       defaultValue: "Commercial / Office",
//                     })}
//                   </option>
//                   <option value="mixed_use">
//                     {t("fullBuilding.form.building.mixed_use", {
//                       defaultValue: "Mixed-use",
//                     })}
//                   </option>
//                 </select>
//               </div>

//               {/* Floors + Location */}
//               <div className="fb-form-row">
//                 <div className="fb-form-group">
//                   <label htmlFor="floors">
//                     {t("fullBuilding.form.floors", {
//                       defaultValue: "Number of floors",
//                     })}
//                   </label>
//                   <input
//                     type="number"
//                     id="floors"
//                     name="floors"
//                     min="1"
//                     placeholder={t("fullBuilding.form.floors_placeholder", {
//                       defaultValue: "e.g. 8",
//                     })}
//                     value={form.floors}
//                     onChange={handleChange}
//                   />
//                 </div>
//                 <div className="fb-form-group">
//                   <label htmlFor="location">
//                     {t("fullBuilding.form.location", {
//                       defaultValue: "Building location / area",
//                     })}
//                   </label>
//                   <input
//                     type="text"
//                     id="location"
//                     name="location"
//                     placeholder={t(
//                       "fullBuilding.form.location_placeholder",
//                       { defaultValue: "Area, city (e.g. Mirpur, Dhaka)" }
//                     )}
//                     value={form.location}
//                     onChange={handleChange}
//                   />
//                 </div>
//               </div>

//               {/* Date / Time */}
//               <div className="fb-form-row">
//                 <div className="fb-form-group">
//                   <label htmlFor="preferredDate">
//                     {t("fullBuilding.form.preferredDate", {
//                       defaultValue: "Preferred visit date",
//                     })}
//                   </label>
//                   <input
//                     type="date"
//                     id="preferredDate"
//                     name="preferredDate"
//                     value={form.preferredDate}
//                     onChange={handleChange}
//                   />
//                 </div>
//                 <div className="fb-form-group">
//                   <label htmlFor="preferredTime">
//                     {t("fullBuilding.form.preferredTime", {
//                       defaultValue: "Preferred time slot",
//                     })}
//                   </label>
//                   <input
//                     type="text"
//                     id="preferredTime"
//                     name="preferredTime"
//                     placeholder={t(
//                       "fullBuilding.form.preferredTime_placeholder",
//                       { defaultValue: "e.g. 10am–1pm" }
//                     )}
//                     value={form.preferredTime}
//                     onChange={handleChange}
//                   />
//                 </div>
//               </div>

//               {/* Budget */}
//               <div className="fb-form-group">
//                 <label htmlFor="budgetRange">
//                   {t("fullBuilding.form.budgetRange", {
//                     defaultValue: "Approximate budget (optional)",
//                   })}
//                 </label>
//                 <input
//                   type="text"
//                   id="budgetRange"
//                   name="budgetRange"
//                   placeholder={t(
//                     "fullBuilding.form.budgetRange_placeholder",
//                     { defaultValue: "e.g. 5–7 lakh, or Not sure" }
//                   )}
//                   value={form.budgetRange}
//                   onChange={handleChange}
//                 />
//               </div>

//               {/* Details */}
//               <div className="fb-form-group">
//                 <label htmlFor="details">
//                   {t("fullBuilding.form.details", {
//                     defaultValue: "Project details / description",
//                   })}{" "}
//                   <span className="fb-required">*</span>
//                 </label>
//                 <textarea
//                   id="details"
//                   name="details"
//                   rows={5}
//                   required
//                   placeholder={t("fullBuilding.form.details_placeholder", {
//                     defaultValue:
//                       "Please mention scope (electric/plumbing/painting/interior), total flats, any existing drawings, timelines, and any other important notes.",
//                   })}
//                   value={form.details}
//                   onChange={handleChange}
//                 />
//               </div>

//               {/* Info line */}
//               <p className="fb-form-note">
//                 <i className="fas fa-info-circle" />{" "}
//                 {t("fullBuilding.form.note", {
//                   defaultValue:
//                     "Our team will review your request and contact you by phone to discuss next steps and site visit.",
//                 })}
//               </p>

//               {/* Submit */}
//               <div className="fb-form-actions">
//                 <button
//                   type="submit"
//                   className="fb-submit-btn"
//                   disabled={submitting}
//                 >
//                   {submitting ? (
//                     <span>
//                       <i className="fas fa-spinner fa-spin" />{" "}
//                       {t("fullBuilding.form.submitting", {
//                         defaultValue: "Sending request...",
//                       })}
//                     </span>
//                   ) : (
//                     <span>
//                       <i className="fas fa-paper-plane" />{" "}
//                       {t("fullBuilding.form.submit", {
//                         defaultValue: "Submit Building Request",
//                       })}
//                     </span>
//                   )}
//                 </button>

//                 {submitted && (
//                   <span className="fb-form-success">
//                     <i className="fas fa-check-circle" />{" "}
//                     {t("fullBuilding.form.success", {
//                       defaultValue:
//                         "Thank you! We’ve received your request. Our team will contact you soon.",
//                     })}
//                   </span>
//                 )}
//               </div>
//             </form>
//           </div>
//         </section>
//       </main>

//       {/* Bottom back button */}
//       <section className="fb-back-section">
//         <div className="fb-back-container">
//           <button
//             type="button"
//             className="fb-back-btn fb-back-btn-bottom"
//             onClick={() => navigate(-1)}
//           >
//             <i className="fas fa-arrow-left" aria-hidden="true" />
//             <span>
//               {t("fullBuilding.back", {
//                 defaultValue: "Back",
//               })}
//             </span>
//           </button>
//         </div>
//       </section>

//       <Footer />
//     </>
//   );
// };

// export default FullBuildingService;








import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { jwtDecode } from "jwt-decode";

import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer/Footer";
import PromptLoginCard from "../Services/PromptLoginCard";
import "./FullBuildingService.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa";
import { URL } from "../../config";
import { useLocalStorageState } from "../../Components/Hooks/useLocalStorageState";
import SEO from "../../Components/SEO/SEO";


const FULL_BUILDING_DRAFT_KEY = "fullBuilding:draft:v1";

const INITIAL_FORM = {
  serviceType: "",
  buildingType: "",
  floors: "",
  location: "",
  preferredDate: "",
  preferredTime: "",
  budgetRange: "",
  details: "",
};


const FullBuildingService = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);

  // const [form, setForm] = useState({
  //   serviceType: "",
  //   buildingType: "",
  //   floors: "",
  //   location: "",
  //   preferredDate: "",
  //   preferredTime: "",
  //   budgetRange: "",
  //   details: "",
  // });

  const [form, setForm] = useLocalStorageState(FULL_BUILDING_DRAFT_KEY, INITIAL_FORM);

  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  // field-level error flags
  const [errors, setErrors] = useState({
    serviceType: false,
    preferredDate: false,
    preferredTime: false,
    details: false,
  });

  // 🔁 refs for scroll-to-error
  const serviceTypeRef = useRef(null);
  const dateRef = useRef(null);
  const timeRef = useRef(null);
  const detailsRef = useRef(null);

  // 🔐 Fetch logged-in user same style as ACService
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          setLoadingUser(false);
          return;
        }

        const decoded = jwtDecode(token);
        // token payload has Id like "user-123" or "servitor-45"
        let userId = decoded.Id;
        if (typeof userId === "string" && userId.startsWith("user-")) {
          userId = userId.split("user-")[1];
        }

        const res = await axios.get(`${URL}/user/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setUser(res.data);
      } catch (err) {
        console.error("Error fetching user data for full building:", err);
      } finally {
        setLoadingUser(false);
      }
    };

    fetchUserData();
    window.scrollTo(0, 0);
  }, []);


// when component mounts, restore selectedDate from saved form.preferredDate (if any)
  useEffect(() => {
  if (form.preferredDate) {
    const [y, m, d] = form.preferredDate.split("-");
    const parsed = new Date(Number(y), Number(m) - 1, Number(d));
    if (!isNaN(parsed)) {
      setSelectedDate(parsed);
    }
  }
  // we only want to do this on initial mount
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);



  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));

    // clear field-specific error as user types
    if (name === "serviceType" && value) {
      setErrors((prev) => ({ ...prev, serviceType: false }));
    }
    if (name === "preferredDate" && value) {
      setErrors((prev) => ({ ...prev, preferredDate: false }));
    }
    if (name === "preferredTime" && value.trim()) {
      setErrors((prev) => ({ ...prev, preferredTime: false }));
    }
    if (name === "details" && value.trim()) {
      setErrors((prev) => ({ ...prev, details: false }));
    }
  };


  const handleDateChange = (date) => {
  setSelectedDate(date);

  if (date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    // Store in backend-friendly YYYY-MM-DD format
    const isoDate = `${year}-${month}-${day}`;

    setForm((prev) => ({
      ...prev,
      preferredDate: isoDate,
    }));

    setErrors((prev) => ({ ...prev, preferredDate: false }));
  } else {
    setForm((prev) => ({
      ...prev,
      preferredDate: "",
    }));
  }
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setSubmitted(false);

    // ---- custom validation for required fields ----
    const newErrors = {
      serviceType: false,
      preferredDate: false,
      preferredTime: false,
      details: false,
    };

    if (!form.serviceType) {
      newErrors.serviceType = true;
    }
    if (!form.preferredDate) {
      newErrors.preferredDate = true;
    }
    if (!form.preferredTime.trim()) {
      newErrors.preferredTime = true;
    }
    if (!form.details.trim()) {
      newErrors.details = true;
    }

    // If any error → scroll to first and stop
    if (
      newErrors.serviceType ||
      newErrors.preferredDate ||
      newErrors.preferredTime ||
      newErrors.details
    ) {
      setErrors(newErrors);

      let targetRef = null;
      if (newErrors.serviceType) targetRef = serviceTypeRef;
      else if (newErrors.preferredDate) targetRef = dateRef;
      else if (newErrors.preferredTime) targetRef = timeRef;
      else if (newErrors.details) targetRef = detailsRef;

      if (targetRef && targetRef.current) {
        targetRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        const inputEl = targetRef.current.querySelector("select, input, textarea");
        if (inputEl && inputEl.focus) inputEl.focus();
      }

      setErrorMsg(
        t("fullBuilding.form.validation_error", {
          defaultValue: "Please fill in all required fields marked with *.",
        })
      );

      return;
    }

    // ---- Login check AFTER validation ----
    if (!user && !loadingUser) {
      setShowLoginPrompt(true);
      return;
    }
    if (!user && loadingUser) return;

    setSubmitting(true);

    try {
      const payload = {
        userId: user.Id,
        serviceType: form.serviceType,
        buildingType: form.buildingType,
        floors: form.floors,
        location: form.location,
        preferredDate: form.preferredDate, // YYYY-MM-DD stored
        preferredTime: form.preferredTime,
        budgetRange: form.budgetRange,
        details: form.details,
      };

      // const { data } = await axios.post(`${URL}/full-building`, payload);
      // console.log("Full building request created:", data);
      await axios.post(`${URL}/full-building`, payload);
      setSubmitted(true);
      // setForm({
      //   serviceType: "",
      //   buildingType: "",
      //   floors: "",
      //   location: "",
      //   preferredDate: "",
      //   preferredTime: "",
      //   budgetRange: "",
      //   details: "",
      // });

      setForm(INITIAL_FORM);

      setSelectedDate(null);
      setErrors({
        serviceType: false,
        preferredDate: false,
        preferredTime: false,
        details: false,
      });
    } catch (err) {
      console.error("Error submitting full building request:", err);
      setErrorMsg(
        t("fullBuilding.form.error", {
          defaultValue: "Something went wrong. Please try again.",
        })
      );
    } finally {
      setSubmitting(false);
    }
  };

  const fullName = user
    ? `${user.FirstName || ""} ${user.LastName || ""}`.trim()
    : "";
  const mobile = user?.mobile || "";

  // For min date on date input (today)
//   const todayStr = new Date().toISOString().split("T")[0];

  return (
    <>

    <SEO
      title="Full Building Service & Renovation in Dhaka | HelpNao"
      description="Request full building solutions: electrical, plumbing, AC, painting, interior, renovation, architectural planning & design. Get a customized quotation and dedicated project coordination."
      path="/services/full-building"
      lang="en"
      jsonLd={{
        "@context": "https://schema.org",
        "@type": "Service",
        "name": "Full Building Service Request",
        "serviceType": "Building Renovation & Maintenance",
        "provider": { "@type": "Organization", "name": "HelpNao", "url": "https://helpnao.com" },
        // "areaServed": { "@type": "City", "name": "Dhaka" },
        "areaServed": [
          { "@type": "Country", "name": "Bangladesh" },
          { "@type": "City", "name": "Dhaka" },
          { "@type": "City", "name": "Chattogram" },
          { "@type": "City", "name": "Khulna" },
          { "@type": "City", "name": "Barishal" },
          { "@type": "City", "name": "Rajshahi" },
          { "@type": "City", "name": "Sylhet" },
          { "@type": "City", "name": "Rangpur" },
          { "@type": "City", "name": "Mymensingh" }
        ],
        "isRelatedTo": [
          { "@type": "Service", "name": "Electrical Work" },
          { "@type": "Service", "name": "Plumbing Work" },
          { "@type": "Service", "name": "AC Installation & Repair" },
          { "@type": "Service", "name": "Painting & Finishing" },
          { "@type": "Service", "name": "Interior Design & Fit-out" },
          { "@type": "Service", "name": "Architectural Design & Planning" }
        ]
      }}
    />


      <Navbar />

      <main className="fb-page">
        <section className="fb-hero">
          <div className="fb-hero-container">
            <div className="fb-hero-text">
              <h1>
                {t("fullBuilding.title", {
                  defaultValue: "Full Building Service Request",
                })}
              </h1>
              <p>
                {t("fullBuilding.subtitle", {
                  defaultValue:
                    "Planning work for an entire building or project? Share your details and our team will coordinate a tailored solution for electrical, plumbing, painting, interior and more.",
                })}
              </p>

              <div className="fb-hero-tags">
                <span>
                  <i className="fas fa-city" />{" "}
                  {t("fullBuilding.tag_projects", {
                    defaultValue: "Apartments, offices & complexes",
                  })}
                </span>
                <span>
                  <i className="fas fa-users-cog" />{" "}
                  {t("fullBuilding.tag_team", {
                    defaultValue: "Dedicated project coordination",
                  })}
                </span>
                <span>
                  <i className="fas fa-file-invoice-dollar" />{" "}
                  {t("fullBuilding.tag_quote", {
                    defaultValue: "Custom quotation",
                  })}
                </span>
              </div>
            </div>

            <div className="fb-hero-sidecard">
              <div className="fb-sidecard-header">
                <div className="fb-sidecard-icon">
                  <i className="fas fa-building" />
                </div>
                <h3>
                  {t("fullBuilding.side.title", {
                    defaultValue: "Ideal For",
                  })}
                </h3>
              </div>

              <ul>
                <li>
                  {t("fullBuilding.side.item1", {
                    defaultValue: "Newly constructed full buildings",
                  })}
                </li>
                <li>
                  {t("fullBuilding.side.item2", {
                    defaultValue: "Full renovation projects",
                  })}
                </li>
                <li>
                  {t("fullBuilding.side.item3", {
                    defaultValue: "Multiple flats under one owner",
                  })}
                </li>
                <li>
                  {t("fullBuilding.side.item4", {
                    defaultValue: "Corporate / commercial spaces",
                  })}
                </li>
              </ul>
            </div>
          </div>
        </section>

        <section className="fb-form-section">
          <div className="fb-form-container">
            <div className="fb-form-header">
              <h2>
                {t("fullBuilding.form.title", {
                  defaultValue: "Tell us about your building",
                })}
              </h2>
              <p>
                {t("fullBuilding.form.subtitle", {
                  defaultValue:
                    "Please share the relevant details so our team can contact you with an accurate plan, guidance, and quotation.",
                })}
              </p>
            </div>

            <form className="fb-form" onSubmit={handleSubmit}>
              {/* Contact Info (read-only) */}
              <div className="fb-form-row">
                <div className="fb-form-group">
                  <label>
                    {t("fullBuilding.form.name", {
                      defaultValue: "Your Name",
                    })}
                  </label>
                  <input
                    type="text"
                    value={fullName}
                    readOnly
                    placeholder={
                      user
                        ? ""
                        : t("fullBuilding.form.name_placeholder", {
                            defaultValue: "Login to auto-fill your name",
                          })
                    }
                  />
                </div>
                <div className="fb-form-group">
                  <label>
                    {t("fullBuilding.form.mobile", {
                      defaultValue: "Mobile Number",
                    })}
                  </label>
                  <input
                    type="text"
                    value={mobile}
                    readOnly
                    placeholder={
                      user
                        ? ""
                        : t("fullBuilding.form.mobile_placeholder", {
                            defaultValue: "Login to auto-fill your mobile",
                          })
                    }
                  />
                </div>
              </div>

              {/* Service Type (required) */}
              <div
                className={`fb-form-group ${
                  errors.serviceType ? "fb-error" : ""
                }`}
                ref={serviceTypeRef}
              >
                <label htmlFor="serviceType">
                  {t("fullBuilding.form.serviceType", {
                    defaultValue: "Required building service",
                  })}{" "}
                  <span className="fb-required">*</span>
                </label>
                <select
                  id="serviceType"
                  name="serviceType"
                  value={form.serviceType}
                  onChange={handleChange}
                >
                  <option value="">
                    {t("fullBuilding.form.service_placeholder", {
                      defaultValue: "Select service type",
                    })}
                  </option>
                  <option value="full_electric">
                    {t("fullBuilding.form.options.full_electric", {
                      defaultValue: "Full Building Electrical Service",
                    })}
                  </option>
                  <option value="full_plumbing">
                    {t("fullBuilding.form.options.full_plumbing", {
                      defaultValue: "Full Building Plumbing Service",
                    })}
                  </option>
                  <option value="full_painting">
                    {t("fullBuilding.form.options.full_painting", {
                      defaultValue: "Full Building Painting Service",
                    })}
                  </option>
                  {/* <option value="full_interior">
                    {t("fullBuilding.form.options.full_interior", {
                      defaultValue: "Full Building Interior Service",
                    })}
                  </option> */}

                  <option value="full_interior">
                    {t("fullBuilding.form.options.full_interior", {
                      defaultValue: "Full Building Interior (all flats & common areas)",
                    })}
                  </option>

                  {/* 🔹 New options */}
                  <option value="full_construction">
                    {t("fullBuilding.form.options.full_construction", {
                      defaultValue: "Full Building Construction (turnkey / project-based)",
                    })}
                  </option>

                  <option value="full_architecture">
                    {t("fullBuilding.form.options.full_architecture", {
                      defaultValue: "Full Building Architectural Design & Planning",
                    })}
                  </option>

                  <option value="flat_room_design">
                    {t("fullBuilding.form.options.flat_room_design", {
                      defaultValue: "Single Flat / Room Interior or Layout Design",
                    })}
                  </option>

                  <option value="mixed">
                    {t("fullBuilding.form.options.mixed", {
                      defaultValue: "Combination / Multiple Services",
                    })}
                  </option>
                </select>
              </div>

              {/* Building Type (optional) */}
              <div className="fb-form-group">
                <label htmlFor="buildingType">
                  {t("fullBuilding.form.buildingType", {
                    defaultValue: "Building type",
                  })}
                </label>
                <select
                  id="buildingType"
                  name="buildingType"
                  value={form.buildingType}
                  onChange={handleChange}
                >
                  <option value="">
                    {t("fullBuilding.form.building_placeholder", {
                      defaultValue: "Select building type (optional)",
                    })}
                  </option>
                  <option value="residential">
                    {t("fullBuilding.form.building.residential", {
                      defaultValue: "Residential (apartment / flat)",
                    })}
                  </option>
                  <option value="commercial">
                    {t("fullBuilding.form.building.commercial", {
                      defaultValue: "Commercial / Office",
                    })}
                  </option>
                  <option value="mixed_use">
                    {t("fullBuilding.form.building.mixed_use", {
                      defaultValue: "Mixed-use",
                    })}
                  </option>
                </select>
              </div>

              {/* Floors + Location */}
              <div className="fb-form-row">
                <div className="fb-form-group">
                  <label htmlFor="floors">
                    {t("fullBuilding.form.floors", {
                      defaultValue: "Number of floors",
                    })}
                  </label>
                  <input
                    type="number"
                    id="floors"
                    name="floors"
                    min="1"
                    placeholder={t("fullBuilding.form.floors_placeholder", {
                      defaultValue: "e.g. 8",
                    })}
                    value={form.floors}
                    onChange={handleChange}
                  />
                </div>
                <div className="fb-form-group">
                  <label htmlFor="location">
                    {t("fullBuilding.form.location", {
                      defaultValue: "Building location / area",
                    })}
                  </label>
                  <input
                    type="text"
                    id="location"
                    name="location"
                    placeholder={t(
                      "fullBuilding.form.location_placeholder",
                      { defaultValue: "Area, city (e.g. Mirpur, Dhaka)" }
                    )}
                    value={form.location}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Date / Time (BOTH required) */}
              <div className="fb-form-row">
                <div
                  className={`fb-form-group ${
                    errors.preferredDate ? "fb-error" : ""
                  }`}
                  ref={dateRef}
                >
                  <label htmlFor="preferredDate">
                    {t("fullBuilding.form.preferredDate", {
                      defaultValue: "Preferred visit date",
                    })}{" "}
                    <span className="fb-required">*</span>
                  </label>
                  <div className="fb-date-wrapper">
                    <DatePicker
                        selected={selectedDate}
                        onChange={handleDateChange}
                        dateFormat="dd-MMM-yyyy" // e.g. 10-Dec-2025
                        minDate={new Date()}
                        placeholderText={t("fullBuilding.form.preferredDate_placeholder", {
                        defaultValue: "Select visit date",
                        })}
                        className="fb-date-input"
                        id="preferredDate"
                    />
                    <FaCalendarAlt
                        className="fb-date-icon"
                        onClick={() => {
                        const input = dateRef.current?.querySelector("input");
                        if (input) input.focus();
                        }}
                    />
                    </div>
                </div>
                <div
                  className={`fb-form-group ${
                    errors.preferredTime ? "fb-error" : ""
                  }`}
                  ref={timeRef}
                >
                  <label htmlFor="preferredTime">
                    {t("fullBuilding.form.preferredTime", {
                      defaultValue: "Preferred time slot",
                    })}{" "}
                    <span className="fb-required">*</span>
                  </label>
                  <input
                    type="text"
                    id="preferredTime"
                    name="preferredTime"
                    placeholder={t(
                      "fullBuilding.form.preferredTime_placeholder",
                      { defaultValue: "e.g. 10am–1pm" }
                    )}
                    value={form.preferredTime}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Budget (optional) */}
              <div className="fb-form-group">
                <label htmlFor="budgetRange">
                  {t("fullBuilding.form.budgetRange", {
                    defaultValue: "Approximate budget (optional)",
                  })}
                </label>
                <input
                  type="text"
                  id="budgetRange"
                  name="budgetRange"
                  placeholder={t(
                    "fullBuilding.form.budgetRange_placeholder",
                    { defaultValue: "e.g. 5–7 lakh, or Not sure" }
                  )}
                  value={form.budgetRange}
                  onChange={handleChange}
                />
              </div>

              {/* Details (required) */}
              <div
                className={`fb-form-group ${
                  errors.details ? "fb-error" : ""
                }`}
                ref={detailsRef}
              >
                <label htmlFor="details">
                  {t("fullBuilding.form.details", {
                    defaultValue: "Project details / description",
                  })}{" "}
                  <span className="fb-required">*</span>
                </label>
                <textarea
                  id="details"
                  name="details"
                  rows={5}
                  placeholder={t(
                    "fullBuilding.form.details_placeholder",
                    {
                      defaultValue:
                        "Please mention scope (electric/plumbing/painting/interior), total flats, any existing drawings, timelines, and any other important notes.",
                    }
                  )}
                  value={form.details}
                  onChange={handleChange}
                />
              </div>

              {/* Info line */}
              <p className="fb-form-note">
                <i className="fas fa-info-circle" />{" "}
                {t("fullBuilding.form.note", {
                  defaultValue:
                    "Our team will review your request and contact you by phone to discuss next steps and site visit.",
                })}
              </p>

              {errorMsg && (
                <p className="fb-form-error">
                  <i className="fas fa-exclamation-circle" /> {errorMsg}
                </p>
              )}

              {/* Submit */}
              <div className="fb-form-actions">
                <button
                  type="submit"
                  className="fb-submit-btn"
                  disabled={submitting}
                  aria-busy={submitting}
                >
                  {submitting ? (
                    <span>
                      <i className="fas fa-spinner fa-spin" />{" "}
                      {t("fullBuilding.form.submitting", {
                        defaultValue: "Sending request...",
                      })}
                    </span>
                  ) : (
                    <span>
                      <i className="fas fa-paper-plane" />{" "}
                      {t("fullBuilding.form.submit", {
                        defaultValue: "Submit Building Request",
                      })}
                    </span>
                  )}
                </button>

                {submitted && (
                  <span className="fb-form-success">
                    <i className="fas fa-check-circle" />{" "}
                    {t("fullBuilding.form.success", {
                      defaultValue:
                        "Thank you! We’ve received your request. Our team will contact you soon.",
                    })}
                  </span>
                )}
              </div>
            </form>
          </div>
        </section>
      </main>

      {/* Bottom back button */}
      <section className="fb-back-section">
        <div className="fb-back-container">
          <button
            type="button"
            className="fb-back-btn fb-back-btn-bottom"
            onClick={() => navigate(-1)}
          >
            <i className="fas fa-arrow-left" aria-hidden="true" />
            <span>
              {t("fullBuilding.back", {
                defaultValue: "Back",
              })}
            </span>
          </button>
        </div>
      </section>

      <Footer />

      {showLoginPrompt && (
        <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />
      )}
    </>
  );
};

export default FullBuildingService;
